export default "__VITE_ASSET__BRvA1arJ__"